// extracted by mini-css-extract-plugin
export default {"wrapHasUnperformed":"summary_wrapHasUnperformed__YAuWE","placeHolderShimmer":"summary_placeHolderShimmer__tyEG6"};